import { ReactElement } from 'react';
import type { Topic } from './types';
import { Dialog, DialogContent } from '@ff-it/ui';
import { useNavigationState } from './useNavigationState';
import { CommentBadge } from './CommentBadge';
import { CommentStream } from './CommentStream';
import { useCommentTopic } from './useCommentTopic';

export function CommentDialogToggle({ topic }: { topic: Topic }): ReactElement {
  const commentTopic = useCommentTopic(topic);
  const { isOpen, open, close, commentId } = useNavigationState(topic.object_key);
  return (
    <>
      <CommentBadge
        objectKey={commentTopic.objectKey}
        count={commentTopic.state.count}
        updates={commentTopic.state.updates}
        active={isOpen}
        onClick={() => open()}
      />
      <Dialog
        open={isOpen}
        onOpenChange={(open) => {
          if (!open) {
            close();
          }
        }}
      >
        <DialogContent testId="comment-stream" right overflow="hidden" p="0">
          {isOpen && <CommentStream topic={commentTopic} commentId={commentId} />}
        </DialogContent>
      </Dialog>
    </>
  );
}
